import styled from 'styled-components';

export const CustomBadgeStyled = styled.div(({ theme, upperCase, textColor, backgroundColor, marginBottom }) => ({
  display: 'flex',

  '.wrapper': {
    color: textColor ?? theme?.color?.white,
    background: backgroundColor ?? 'red',
    display: 'inline-flex',
    fontSize: '13px',
    fontWeight: 600,
    padding: '3px 6px',
    borderRadius: '0 4px 4px 0',
    textTransform: upperCase ? 'uppercase' : '',
    marginBottom: marginBottom ?? '8px',
  },
}));
